export default __webpack_public_path__ + "static/media/Oral-Health.026b9db5.jpg";